export const REPORT_TEMPLATE_TYPES = {
  UPDATED: 'new',
  CLASSIC: 'old',
};
